class ModalCancelledError extends Error {
}

module.exports = {
    ModalCancelledError,
};
